export default __webpack_public_path__ + "static/media/logo.251c98b2.png";